import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IClassEvent, IClassEventPublic} from "../../models/ClassEvent";

interface ClassEventState {
    classEvents: IClassEvent[],
    publicClassEvents: IClassEventPublic[]
    isLoading: boolean,
}

const initialState: ClassEventState = {
    classEvents: [],
    publicClassEvents: [],
    isLoading: true,
}

export const classEventSlice = createSlice({
    name: "classEvent",
    initialState,
    reducers: {
        setClassEvents: (state, action: PayloadAction<IClassEvent[]>) => {
            state.classEvents = action.payload.filter(el => el.type !== "reservation");
            state.isLoading = false;
            state.publicClassEvents = [];
        },
        setPublicClassEvents: (state, action: PayloadAction<IClassEventPublic[]>) => {
            state.classEvents = [];
            state.isLoading = false;
            state.publicClassEvents = action.payload;
        },
        loaderUpdate: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        }
    }
})

export const {setClassEvents, setPublicClassEvents, loaderUpdate} = classEventSlice.actions;

export default classEventSlice.reducer;